<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="d-flex align-items-center">
        <b-col>
          <h3>Genel Bilgiler</h3>
        </b-col>
        <b-col md="auto">
          <div class="text-right">
            <b-button
              variant="primary"
              :to="$route.path + '/files/add'"
            >
              <FeatherIcon icon="PlusIcon" /> Oluştur
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="dataLoading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">Yükleniyor...</strong>
        </div>
      </template>
      <template #cell(file_size)="data">
        <div>{{ data.item.file_size | fileSizeFromKB }}</div>
      </template>
      <template #cell(username)="data">
        {{ data.item.username }}
        <div v-if="data.item.created">
          <small class="text-primary">
            <feather-icon icon="SaveIcon" />
            {{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}
          </small>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action=" $route.path + '/files/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
          <download-file
            file-component="projects"
            :file-id="Number(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DownloadFile from '@/layouts/components/DownloadFile.vue'

const tableName = 'project_files'
export default {
  name: 'ProjectFiles',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BRow,
    BCol,
    BSpinner,
    DownloadFile,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Dosya',
        },
        {
          key: 'file_size',
          label: 'BOYUT',
          thClass: 'width-100 text-nowrap text-right',
          tdClass: 'width-100 text-nowrap text-right',
        },
        {
          key: 'document_groups',
          label: 'Dosya Grubu',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'username',
          label: 'Ekleyen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.file_size AS file_size`,
          `${tableName}.is_secret AS is_secret`,
          `${tableName}.created AS created`,
          'document_groups.title AS document_groups',
          'users.name AS username',
        ],
        where: {
          'project_files.is_secret': '0',
          'project_files.id_projects': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projectFiles/dataList']
    },
    dataCounts() {
      return this.$store.getters['projectFiles/dataCounts']
    },
    saveData() {
      return this.$store.getters['projectFiles/dataSaveStatus']
    },
    dataLoading() {
      return this.$store.getters['projectFiles/loading']
    },
    emptyText() {
      if (this.dataLoading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.where['project_files.id_projects'] = this.$route.params.id
      this.$store.dispatch('projectFiles/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projectFiles/removeData', id)
            .then(response => {
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'İşlem Uyarısı!',
                  text: response.message,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
